import { Box, Button, Text } from '@betty/moonlight';
import PromosBadgeList from '../PromosBadgeList/PromosBadgeList';
import PromoCta from '../PromoCta/PromoCta';
import { selectOptOutPending } from '../../state/promos/promos.slice';
import { useSelector } from '@betty/toolkit/state';
import { BottomSheet } from '@betty/navigation';
import { memo, useCallback } from 'react';
import { PromoSummaryProps } from './PromoSummary.types';

function PromoSummary({ promo }: PromoSummaryProps) {
  const {
    promotionId,
    title,
    shortDescription,
    isOptedIn,
    rewards,
    status,
    promoType,
  } = promo;
  const isLoading = useSelector(selectOptOutPending(promotionId));

  const onOptOutClick = useCallback(() => {
    BottomSheet.open({
      namespace: 'promos',
      type: 'OptOutPromo',
      data: {
        promotionId,
      },
    });
  }, [promotionId]);

  return (
    <Box gap="space-200">
      <Text variant="h4" gradient="darkSurfaceAccent">
        {title}
      </Text>
      <PromosBadgeList rewards={rewards ?? []} />
      <Text variant="body-m-semi" color="darkSurfacePrimary">
        {shortDescription}
      </Text>
      <Box gap="space-300" marginTop="space-200" marginBottom="space-200">
        {status === 'Locked' ? null : <PromoCta promo={promo} />}
        {promoType !== 'Welcome' && isOptedIn ? (
          <Button
            variant="secondary"
            alignSelf="center"
            locNS="promos"
            locKey="optOut"
            onPress={onOptOutClick}
            loading={isLoading}
            width="100%"
          />
        ) : null}
      </Box>
    </Box>
  );
}

export default memo(PromoSummary);
